<div style="display: flex; width: 100vw; height: 100vh; justify-content: center; align-items: center;">

  <div style="display: flex; flex-direction: column;">
    <h1>Welcome</h1>
    <a mat-raised-button color="primary" href="/assets/student-files.zip">Download Lab Files</a>
    <a mat-raised-button color="primary" (click)="startLabSession()">Start New Lab Session</a>
  </div>

</div>